import { Fragment } from "react";
import { Link } from "react-router-dom";

const isInternal = (href = "") =>
  href.startsWith("/") && !href.startsWith("//");

const renderBlock = (block, key) => {
  const html = { __html: block.html || block.text };

  if (block.type === "heading") {
    const Tag = `h${block.level || 2}`;
    return <Tag dangerouslySetInnerHTML={html} key={key} />;
  }

  if (block.type === "date") {
    return <time dangerouslySetInnerHTML={html} key={key} />;
  }

  if (block.type === "blockquote") {
    return <blockquote dangerouslySetInnerHTML={html} key={key} />;
  }

  if (block.type === "caption") {
    return <figcaption dangerouslySetInnerHTML={html} key={key} />;
  }

  if (block.type === "link") {
    if (block.isButton) return null;
    if (isInternal(block.href)) {
      return (
        <Link
          dangerouslySetInnerHTML={html}
          key={key}
          to={block.href}
        />
      );
    }
    return (
      <a
        dangerouslySetInnerHTML={html}
        href={block.href}
        key={key}
        rel={block.href?.startsWith("http") ? "noreferrer" : undefined}
      />
    );
  }

  return <p dangerouslySetInnerHTML={html} key={key} />;
};

export default function ContentBlocks({ blocks = [] }) {
  const output = [];

  for (let index = 0; index < blocks.length; index += 1) {
    const block = blocks[index];
    if (
      block.type === "date" &&
      index > 0 &&
      blocks[index - 1].type === "date" &&
      blocks[index - 1].text === block.text
    ) {
      continue;
    }

    if (block.type !== "listItem") {
      const rendered = renderBlock(block, `${index}-${block.text}`);
      if (rendered) output.push(rendered);
      continue;
    }

    const listItems = [];
    let listIndex = index;
    while (
      listIndex < blocks.length &&
      blocks[listIndex].type === "listItem"
    ) {
      listItems.push(blocks[listIndex]);
      listIndex += 1;
    }

    output.push(
      <ul key={`list-${index}`}>
        {listItems.map((item, itemIndex) => (
          <li
            dangerouslySetInnerHTML={{ __html: item.html || item.text }}
            key={`${itemIndex}-${item.text}`}
          />
        ))}
      </ul>,
    );
    index = listIndex - 1;
  }

  return output.map((node, index) => (
    <Fragment key={node.key || index}>{node}</Fragment>
  ));
}
